module.exports = __webpack_public_path__ + "img/20190903145355789.318bd106.jpg";